export { reportAuthOptions } from './user'
export { CaseProcess, CaseTypeIcon } from './case'
export * from './dictionary'

export { FinanceTypeOptions } from './finance'
export * from './home'
export {
  ENCRYPT_JSON,
  APPKEY,
  AUTO_CANCEL_TOKEN_MESSAGE,
  BASE_URL,
  FIRM_PREFIX_URL,
  ASSOCIATION_PREFIX_URL,
  COMMON_API_PREFIX,
} from './http'

export * from './localStorage'

export { REPORT_OBJECT, REPORT_OBJECT_FIRM, REPORT_SUBMIT_SINGLE, REPORT_EXTEND_COLUMNS, REPORT_TYPE } from './report'

export { REPORT_ELEVEN_COLUMNS } from './report-eleven'

export { REPORT_TWELVE_COLUMNS } from './report-twelve'

export { REPORT_THIRTEEN_COLUMNS } from './report-thirteen'

export { REPORT_FOURTEEN_COLUMNS } from './report-fourteen'

export { phoneReg, timeReg } from './regexp'

export { PHONE_TABS, PHONE_TABS_OPTIONS } from './phone'
export * from './help'

export const OSS_URL_Lawyer_Base = 'https://lawyer-association-dev.oss-cn-beijing.aliyuncs.com'
export const COS_URL_Lawyer_Base = 'https://henan-lawyers-1333755895.cos.ap-guangzhou.myqcloud.com'